import type { TimeDimensionPredefinedGranularity } from "@cubejs-client/core";
import type { CubeDimension, Operator } from "./schemas/cube-meta";

export const CREATIVE_TAGS_FOLDER = "Creative tags";

export const MAX_LIMIT = 50_000;
export const MAX_FILTER_DEPTH = 4;
export const MAX_GROUP_CHILDREN = 100;

export const VALUE_OPERATORS = ["equals", "notEquals"] as const;

export const TEXT_OPERATORS = [
  "contains",
  "notContains",
  "startsWith",
  "notStartsWith",
  "endsWith",
  "notEndsWith",
] as const;

export const BOUND_OPERATORS = ["gt", "gte", "lt", "lte"] as const;

export const VIDEO_LENGTH_OPERATORS = ["gte", "lte"] as const;
export type VideoLengthOperator = (typeof VIDEO_LENGTH_OPERATORS)[number];

export const CREATIVE_DURATION_KEY = "duration_seconds";

export const DATE_OPERATORS = [
  "inDateRange",
  "notInDateRange",
  "beforeDate",
  "beforeOrOnDate",
  "afterDate",
  "afterOrOnDate",
] as const;
export type DateOperator = (typeof DATE_OPERATORS)[number];

export const BINARY_OPERATORS = [
  ...VALUE_OPERATORS,
  ...TEXT_OPERATORS,
  ...BOUND_OPERATORS,
  ...DATE_OPERATORS,
] as const;

export const DATE_GRANULARITIES = [
  "second",
  "minute",
  "hour",
  "day",
  "week",
  "month",
  "quarter",
  "year",
] as const satisfies readonly TimeDimensionPredefinedGranularity[];
export type DateGranularity = (typeof DATE_GRANULARITIES)[number];

export const MEMBER_OPERATORS: Record<CubeDimension["type"], Operator[]> = {
  string: [
    "equals",
    "notEquals",
    "contains",
    "notContains",
    "startsWith",
    "notStartsWith",
    "endsWith",
    "notEndsWith",
    "set",
    "notSet",
  ],
  number: ["equals", "notEquals", "gt", "gte", "lt", "lte", "set", "notSet"],
  time: [
    "equals",
    "notEquals",
    "inDateRange",
    "notInDateRange",
    "beforeDate",
    "beforeOrOnDate",
    "afterDate",
    "afterOrOnDate",
    "set",
    "notSet",
  ],
};

export const TAG_OPERATORS: Operator[] = [
  "equals",
  "notEquals",
  "set",
  "notSet",
];
